import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCup"><Path d="M3.5 3.5H16.5V20.5H3.5V3.5Z" stroke="currentColor"/><Path d="M16.5 6.5H20.5V12.5H16.5V6.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCup;
